$( window ).on("load", function() {
    if ($('.boost-pfs-filter-product-item-inner  > .lux_swatch_under_price')) {
      $('.boost-pfs-filter-product-item-grid').addClass('luxreaders-boost-pfs-filter-product-item-grid')
    }
    else{
        if ($('.boost-pfs-filter-product-item-grid').hasClass('luxreaders-boost-pfs-filter-product-item-grid')) {
          $('.boost-pfs-filter-product-item-grid').removeClass('luxreaders-boost-pfs-filter-product-item-grid')
        }
    }
});

class ColorSwatches extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onColorSwatchChange);
    if (this.dataset.event == 'hover') {
      this.querySelectorAll('.product-connected_products-item label.color').forEach(swatch => swatch.addEventListener('mouseenter', this.onColorSwatchHover.bind(this)));
    }
  }

  onColorSwatchHover(event) {
    if (!event.target.previousElementSibling.checked) { // only run if already not active
      event.target.previousElementSibling.checked = true;
      if ("createEvent" in document) {
        var evt = document.createEvent("HTMLEvents");
        evt.initEvent("change", false, true);
        this.dispatchEvent(evt);
      }
      else {
        this.fireEvent("onchange");
      }
    }
  }

  onColorSwatchChange() {
    this.updateProductOptions();
    this.updateMasterId();

    if (this.currentVariant) {
      const activeVariant = this.getProductData().find(product => product.id.toString() === this.connectedProductId);
      this.renderProduct(activeVariant);
    }
  }

  updateProductOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.options = fieldsets.map((fieldset) => {
      return {
        value: Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value,
        connectedProductId: Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).dataset.connectedProductId,
        connectedProductHandle: Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).dataset.handle,
      };
    });
  }

  updateMasterId() {
    this.productId = this.dataset.productId;
    this.connectedProductId = this.options[0].connectedProductId;
    this.connectedProductHandle = this.options[0].connectedProductHandle;
    this.currentVariant = this.options[0].value;
  }

  renderProduct(activeVariant) {
    const parsedHtml = new DOMParser().parseFromString(activeVariant.html, 'text/html');
    const destination = document.querySelector(`#product-item-${this.productId}`);
    const source = parsedHtml.querySelector(`#product-item-${this.connectedProductId}`);

    if (!destination && !source) return;

    // Replace `.product-item__link`
    const destinationProductItemLink = destination.querySelector(".product-link");
    const sourceProductItemLink = source.querySelector(".product-link");
    window.preloadImages(sourceProductItemLink);
    if (destinationProductItemLink && sourceProductItemLink) destinationProductItemLink.replaceWith(sourceProductItemLink);

    const destinationProductItemInfo = destination.querySelector(".product-info");
    const sourceProductItemInfo = source.querySelector(".product-info");
    if (destinationProductItemInfo && sourceProductItemInfo) destinationProductItemInfo.replaceWith(sourceProductItemInfo);
  }

  getProductData() {
    this.productData = this.productData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.productData;
  }
}

ColorSwatches.productData = [];

customElements.define('color-swatches', ColorSwatches);